	export enum ImportEntityTypeEnum {
		ProductCategory = 1,
		Product = 2,
		ProductStyle = 3,
		Manufacturer = 4,
		Vendor = 5,
		ProductGroup = 6,
		Warranty = 7,
		Region = 8,
		Division = 9,
		InsuranceBusinessType = 10,
		InsurancePlanType = 11,
		ServiceCode = 12,
		InsurancePlan = 13,
		Company = 14,
		PriceList = 15,
		PriceListItem = 16,
		InsurancePlanPriceList = 17,
		LicenseType = 18,
		LicenseStateTitle = 19,
		Certification = 20,
		CertificationStateTitle = 21,
		AcademicDegree = 22,
		LicenseProductGroup = 23,
		BillingEntity = 24,
		Brand = 25,
		Area = 26,
		District = 27,
		Kit = 28,
		IcdCode = 29,
		Clinic = 30,
		Provider = 31,
		Patient = 32,
		InsurancePlanProductSetup = 33,
		InsurancePlanContactPerson = 34,
		MaxProductGroupDiscount = 35,
		MaxProductGroupDiscountRegion = 36,
		PatientNote = 37,
		InsurancePlanPriceListBenefit = 38,
		AdditionalTax = 39,
		ClinicDiscountReason = 40,
		ProviderUser = 41,
		PatientEquipment = 42,
		ProviderLicense = 43,
		ClinicWorkingHour = 44,
		ProviderClinic = 45,
		ProviderClinicWorkingHour = 46,
		Authorization = 47,
		PatientInsuranceCode = 48,
		Insurance = 49,
		PatientCms = 50,
		MedicalReport = 51,
		RelatedSubscriber = 52,
		RelatedSubscriberPatient = 53,
		ClinicMonthlyTarget = 54,
		ProviderMonthlyTarget = 55,
		BatterySize = 101,
		InsuranceBenefitPeriod = 102,
		ProductLevel = 103,
		InsuranceGroupQualifier = 104,
		InsurancePlanReference = 105,
		InsuranceType = 106
	}
